import { Children } from 'react';

interface MaterialFormChangerProps {
  step: number;
  label: string;
  children: JSX.Element | JSX.Element[];
}
const MaterialFormChanger: React.FC<MaterialFormChangerProps> = ({
  step,
  children,
}) => {
  const mapChildrens = Children.map(children, (child) => child);

  const jsxElement = mapChildrens[step];

  return jsxElement;
};

export default MaterialFormChanger;
